import React, { useEffect, useRef, useContext } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './NewSection.css';
import { LandingPageContext } from '../../contexts/LandingPageContext';

gsap.registerPlugin(ScrollTrigger);

const NewSection = () => {
    const containerRef = useRef(null);
    const circleRef = useRef(null);
    const { getScrollSmoother } = useContext(LandingPageContext);

    useEffect(() => {
        const smoother = getScrollSmoother && getScrollSmoother();
        // If smoother isn't ready yet, skip — effect will re-run when getScrollSmoother changes
        if (!smoother) return;

        const scroller = smoother.scroller || window;
        const el = circleRef.current;

        const ctx = gsap.context(() => {
            if (!el) return;

            gsap.to(el, {
                scale: 2,
                ease: 'none',
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                    scroller: scroller
                }
            });

            // ensure ScrollTrigger knows about layout changes
            ScrollTrigger.refresh();
        }, containerRef);

        return () => {
            ctx.revert();
            ScrollTrigger.getAll().forEach(st => {
                if (st.trigger === el) st.kill();
            });
        };
    }, [getScrollSmoother]);

    return (
        <div className="room-section" ref={containerRef}>
            <div className="black-square-overlay">
                <div>MÖGL</div>
                <div>ICHKE</div>
                <div>ITSRA</div>
                <div>UM</div>
            </div>
        </div>
    );
};

export default NewSection;
